import { Button, Box, LinearProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

const ProgressBar = ({ steps, currentStep, setCurrentStep }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(((currentStep + 1 - 1) / (steps.length - 1)) * 100);
  }, [currentStep, steps.length]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          position: "relative",
        }}
      >
        {steps.map((_item, index) => (
          <Button
            key={index}
            sx={{
              bgcolor: `${
                currentStep === index
                  ? "#007bff"
                  : currentStep > index
                  ? "#2e8b57"
                  : "#082545"
              }`,
              borderRadius: "50%",
              padding: "15px 15px",
              zIndex: 5,
              color: "#fff",
              WebkitTransition: "1s ease-in-out",
              Transition: "1s ease-in-out",
            }}
            disabled={index > currentStep}
            onClick={() => setCurrentStep(index)}
          >
            <Typography sx={{ color: "#fff" }}>{index + 1}</Typography>
          </Button>
        ))}
        <Box
          sx={{
            width: "100%",
            position: "absolute",
            left: 0,
            bottom: 25,
            WebkitTransition: "1s ease-in-out",
            Transition: "1s ease-in-out",
          }}
        >
          <LinearProgress variant="buffer" value={progress} valueBuffer={100} />
        </Box>
      </Box>
    </>
  );
};

export default ProgressBar;
